import React, { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

import { Layout, Spinner } from '@components/atoms';
import { Page } from '@constants/enum';
import { B2C_START } from '@constants/text';
import { useReduxForm } from '@hooks/useReduxForm';
import _ from 'lodash';

function B2CMain({ setPageIndex }: { setPageIndex: any }): ReactElement {
  const { formData: mbtiFlowFormData } = useReduxForm('mbtiFlow');
  const { formData: surveyFormData } = useReduxForm('survey');
  const location = useLocation();
  // URL이 /mbti/로 시작하면 UUID flow — 진입 즉시 (mbtiFlow.uuid가 set되기 전부터) 비활성으로 시작.
  const isMbtiPath = location.pathname.startsWith('/mbti/');
  // 준비 완료 신호: mbtiFlow.uuid set + survey 생성 완료 (formData.surveyList 채워짐).
  const isReady = !!mbtiFlowFormData?.uuid && !!surveyFormData?.surveyList?.length;
  const isPreparing = isMbtiPath && !isReady;
  return (
    <Layout>
      <div
        style={{
          position: 'absolute',
          left: '-24px',
          paddingLeft: '48px',
          top: '0',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          rowGap: '15px',
          paddingBottom: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            width: 'calc(100% + 48px)',
          }}
        >
          <img alt="한의MBTI" src={`${process.env.PUBLIC_URL}/img/b2c-main.webp`} style={{ width: '100%' }} />
        </div>
        <div
          style={{
            width: 'calc(100% + 48px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            rowGap: '10px',
            textAlign: 'center',
          }}
        >
          <span
            style={{
              fontSize: '24px',
              lineHeight: '1.5em',
              color: '#1d1c1d',
              letterSpacing: '-0.96px',
              fontWeight: 700,
              whiteSpace: 'nowrap',
            }}
          >
            한의진단 MBTI
          </span>
          <span
            style={{
              fontSize: '15px',
              lineHeight: '1.4em',
              color: '#1d1c1d',
              letterSpacing: '-0.15px',
              whiteSpace: 'pre-wrap',
            }}
          >{`내 몸의 상태를 진단하고
나만의 맞춤 약재를 찾아보세요!`}</span>
          <span
            style={{
              fontSize: '15px',
              lineHeight: '1.4em',
              color: '#6c6c6c',
              letterSpacing: '-0.15px',
              whiteSpace: 'pre-wrap',
            }}
          >
            소요시간: 약 7분
          </span>
        </div>
        <button
          disabled={isPreparing}
          onClick={() => {
            if (isPreparing) return;
            setPageIndex(mbtiFlowFormData?.uuid ? Page.DetailSurvey : Page.B2CForm);
          }}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            columnGap: '10px',
            height: '52px',
            width: '100%',
            borderRadius: '20px',
            color: '#FFFFFF',
            background: isPreparing ? '#9bb6d9' : '#2B8FFF',
            fontSize: '20px',
            fontWeight: 700,
            letterSpacing: '0.1px',
            border: 'none',
            cursor: isPreparing ? 'not-allowed' : 'pointer',
            transition: 'background 0.2s ease',
          }}
          type="button"
        >
          {isPreparing ? (
            <>
              <Spinner color="#FFFFFF" size={18} />
              <span>잠시만 기다려주세요</span>
            </>
          ) : (
            B2C_START
          )}
        </button>
      </div>
    </Layout>
  );
}

export default B2CMain;
